import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Chip from '@material-ui/core/Chip';
import { useHistory, useLocation } from 'react-router-dom';
import { useTheme } from '@material-ui/styles';

const StyledBreadcrumb = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.grey[100],
    height: theme.spacing(3),
    fontSize: 12,
    [theme.breakpoints.down('349')]: {
      fontSize: 10,
    },
    padding: 0,
    color: theme.palette.grey[800],
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: theme.palette.grey[100],
    },
  },
}))(Chip);

export const SettingBreadcrumbs = () => {
  const history = useHistory();
  const location = useLocation();
  const theme = useTheme();
  const [label, setLabel] = useState();

  useEffect(() => {
    let routeName = {
      '/account/prefer-location': 'Prefered Meeting Locaitons',
      '/account/profile': 'Personal Information',
      '/account/social-account': 'Social Accounts',
      '/account/location': 'Your Current Location',
      '/account/timezone': 'Time Zone',
      '/account/prefer-time': 'Prefered Meeting Times',
      '/account/change-password': 'Change Password',
    };
    location && setLabel(routeName[location.pathname]);

    return false;
  }, [location]);

  const active = {
    backgroundColor: theme.palette.grey[200],
    height: theme.spacing(3),
    color: theme.palette.grey[900],
    '&:hover, &:focus': {
      backgroundColor: theme.palette.grey[100],
    },
  };

  return (
    <Breadcrumbs aria-label='breadcrumb'>
      <StyledBreadcrumb
        label='Account Settings'
        onClick={() => history.push('/account/profile')}
      />
      <StyledBreadcrumb label={label} style={active} />
    </Breadcrumbs>
  );
};
